export const TableTabIds = {
  HEALTHCARE_PROVIDERS: 'healthcare-providers',
  RECENTLY_VIEWED: 'recently-viewed',
  FAVORITES: 'favorites',
} as const;

type TabKeyType = keyof typeof TableTabIds;

export type TabValueType = (typeof TableTabIds)[TabKeyType];
